import { Rocket } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Запуск клиники силами dodoc (БО-04; DODOC_ADMIN, DODOC_SUPPORT): чек-лист запуска и заполнение базы знаний и
 * расписания от имени клиники — только при действующем доступе поддержки (ПОРТ-03), с предупреждением и журналом.
 */
export const section = defineSection({
  id: 'backoffice.launch',
  area: 'backoffice',
  path: 'launch/*',
  roles: ['DODOC_ADMIN', 'DODOC_SUPPORT'],
  icon: Rocket,
  titleKey: 'boLaunch:title',
  namespaces: ['boClinics', 'boSupport', 'portal', 'schedule', 'backoffice'],
  navGroup: 'clients',
  order: 30,
  load: () => import('./LaunchPage'),
});
